import { Controller } from "@hotwired/stimulus"

// One award's color carousel. Shows a window of colors and pages through the
// rest with the arrows; the arrows stay hidden entirely when everything
// already fits.
//
// How many fit and the gap between them are CSS, not JS -- both are read back
// off the element so the stylesheet stays the single source of truth for the
// geometry. Selecting a color is NOT handled here: that belongs to
// award_catalog_controller, which owns the hidden field the form submits.
export default class extends Controller {
  static targets = ["track", "prev", "next"]

  connect() {
    this.page = 0
    this.update()
  }

  prev() {
    this.page = Math.max(0, this.page - 1)
    this.update()
  }

  next() {
    this.page = Math.min(this.lastPage, this.page + 1)
    this.update()
  }

  update() {
    // Belt and braces: the view only attaches this controller to a set that has
    // colors, but a controller that raises in connect() takes down Stimulus for
    // the entire page -- every other controller included -- so it must not
    // assume its own markup.
    if (!this.hasTrackTarget) return

    // A page step is the full window plus the gap that would follow it, so the
    // first card of the next page lands flush against the left edge. The
    // percentage resolves against the track, whose width IS the window's.
    const gap = this.cssValue("--award-colors-gap", "0px")
    this.trackTarget.style.transform = `translateX(calc(${this.page} * (-100% - ${gap})))`

    const pages = this.lastPage > 0
    this.toggleArrow(this.hasPrevTarget && this.prevTarget, pages, this.page === 0)
    this.toggleArrow(this.hasNextTarget && this.nextTarget, pages, this.page === this.lastPage)
  }

  toggleArrow(arrow, needed, atEnd) {
    if (!arrow) return

    arrow.hidden = !needed
    arrow.disabled = atEnd
  }

  get lastPage() {
    return Math.max(0, Math.ceil(this.trackTarget.children.length / this.perPage) - 1)
  }

  get perPage() {
    return parseInt(this.cssValue("--award-colors-per-page", "4"), 10) || 4
  }

  // Custom properties still resolve while the set is hidden, which matters:
  // every set but the chosen award's is display:none when it connects.
  cssValue(name, fallback) {
    const value = getComputedStyle(this.element).getPropertyValue(name).trim()
    return value || fallback
  }
}
